/**
 * Model Viewer Routing Module
 *
 * @version
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.56.0 OAUI-596 Migrate Large Model Viewer into Angular
 *
 * @author Jenny Lam <jlam@buildcentrix.com>
 * @copyright (c) 2023 Build Centrix
 */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ViewerComponent } from './components/viewer/viewer.component';

const routes: Routes = [
  {
    path: 'view/:orderIndex',
    component: ViewerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModelViewerRoutingModule {}
